<template>
  <div class="companies_container">
    <div class="companies_firstblock_container">
      <b-container class="companies_firstblock">
        <h1 class="pull-left companies_firstblock_title">
          <font-awesome-icon icon="book" />
          Formation télétravail - Pour les entreprises
        </h1>
        <hr />

        <b-row>
          <b-col lg="8" xl="8" sm="12" class="companies_firstblock_leftblock">
            <!-- list with checks -->
            <b-table
              class="companies_firstblock_leftblock_table"
              bordered
              head-variant="dark"
              :items="items"
            ></b-table>
            <hr />
          </b-col>
          <b-col lg="4" xl="4" sm="12" class="companies_firstblock_rightblock">
            <!-- card with prices -->
            <b-card
              title="Formation"
              tag="article"
              style="max-width: 20rem;"
              class="mb-2 companies_firstblock_rightblock_card"
            >
              <b-card-text>
                <hr />
                <font-awesome-icon icon="arrow-right" /> Managers (groupe de 3
                max.) : 1/2j - <b>500 € pour le groupe</b>
                <br />
                <br />
                <font-awesome-icon icon="arrow-right" /> Collaborateurs (groupe
                de 3 max.) - 1/2j : <b>500 € pour le groupe</b>
                <hr />
              </b-card-text>

              <b-button
                squared
                size="lg"
                href="#"
                variant="primary"
                @click="showPurchasePopup('formation')"
                ref="purchasePopupButton"
                request-type="formation"
                >Faire une demande</b-button
              >
              <br />
              <p class="companies_firstblock_rightblock_textunderbtn">
                Formation uniquement à distance pour le moment
              </p>
              <hr />
              <h5 class="card-title">Coaching personnalisé</h5>
              <hr />
              <b-button
                squared
                size="lg"
                href="#"
                variant="success"
                @click="showPurchasePopup('coaching')"
                ref="purchasePopupButton"
                request-type="coaching"
                >Faire une demande</b-button
              >
              <br />
              <p class="companies_firstblock_rightblock_textunderbtn">
                Faire une demande pour plus d'informations - Coaching uniquement
                à distance pour le moment
              </p>
            </b-card>

            <!-- share button -->
            <b-button
              class="margin-20"
              squared
              size="lg"
              @click="showSharePopup"
              ref="sharePopupButton"
              variant="warning"
            >
              <font-awesome-icon icon="share-alt" />
              Partager en 1 clic</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="companies_sellingtext_container">
      <b-container>
        <h1 class="pull-left companies_firstblock_title" style="color: white">
          Le télétravail
          <font-awesome-icon icon="laptop-house" />
        </h1>
        <hr class="white-hr" />
        <b-img
          rounded="0"
          thumbnail
          fluid
          :src="require('../assets/img/teletravail_formation.jpg')"
          alt="coach formation télétravail solo"
          class="companies_remote_img"
        ></b-img>
        <br />
        <b-jumbotron style="padding: 2rem" fluid>
          <p class="companies_sellingtext" v-html="companiesIntro"></p>
          <br />
          <b-button
            squared
            size="lg"
            href="#"
            variant="dark"
            @click="showPurchasePopup('formation')"
            ref="purchasePopupButton"
            request-type="formation"
            >Faire une demande</b-button
          >
        </b-jumbotron>
      </b-container>
    </div>
    <WhoAmI />
    <SharePopup />
    <PurchasePopup :requestType="requestType" />
  </div>
</template>

<script>
import { companiesManagerList, companiesIntro } from "@/data/texts";
import WhoAmI from "@/components/WhoAmI.vue";
import SharePopup from "@/components/SharePopup.vue";
import PurchasePopup from "@/components/PurchasePopup.vue";

export default {
  name: "ForCompanies",
  data() {
    return {
      requestType: "formation",
      items: companiesManagerList,
      companiesIntro: companiesIntro,
    };
  },
  components: {
    WhoAmI,
    SharePopup,
    PurchasePopup,
  },
  methods: {
    showSharePopup() {
      this.$root.$emit("bv::show::modal", "share-popup", "#sharePopupButton");
      this.$ga.event(
        "formation-page",
        "click",
        `share popup`,
        new Date().getTime()
      );
    },
    showPurchasePopup(requestType) {
      this.requestType = requestType;
      this.$emit("update:modal");
      this.$ga.event(
        "formation-page",
        "click",
        `demand type ${requestType}`,
        new Date().getTime()
      );
      this.$root.$emit(
        "bv::show::modal",
        "purchase-popup",
        "#purchasePopupButton"
      );
    },
  },
};
</script>
